import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { getVersionInfo } from "@/utils/versionInfo"
import { useTheme } from "@/contexts/ThemeContext"
import { Button } from "@/components/ui"

export const SettingsPage = () => {
  const navigate = useNavigate()
  const { version, buildTime, buildMode } = getVersionInfo()
  const { theme, setTheme } = useTheme()

  return (
    <div style={{ padding: '16px' }}>
      <header style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '12px' }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', color: 'inherit' }}
          aria-label="뒤로 가기"
        >
          <ArrowLeft size={24} />
        </button>
        <h1 style={{ margin: 0, fontSize: '20px' }}>설정</h1>
      </header>
      
      <section style={{ marginBottom: '24px' }}>
        <h2>테마 설정</h2>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
            <Button 
                variant={theme === 'ocean' ? 'primary' : 'outline'} 
                onClick={() => setTheme('ocean')}
            >
                Ocean (Blue)
            </Button>
            <Button 
                variant={theme === 'forest' ? 'primary' : 'outline'} 
                onClick={() => setTheme('forest')}
            >
                Forest (Green)
            </Button>
        </div>
      </section>

      <hr style={{ margin: '24px 0', border: 'none', borderTop: '1px solid var(--color-border-default)' }} />
      
      <section>
          <h2>앱 정보</h2>
          <p>
            <strong>버전:</strong> {version}
          </p>
          <p>
            <strong>빌드 시간:</strong> {buildTime.toLocaleString()}
          </p>
          <p>
            <strong>빌드 모드:</strong> {buildMode}
          </p>
      </section>
    </div>
  )
}